import { css } from 'emotion';

export const answerContainer = css(`
	position: relative;
	margin: 10px auto 20px;
`);
